import parseISO from "date-fns/parseISO";
// 連想配列入り配列を日付の昇順に並び替える
export default function arraySortByDate(array = [{}], date = "date") {
    return Array.from(array).sort((a, b) => parseISO(a[date]) - parseISO(b[date]));
}
